import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Боковые поля экрана: одна колонка на всё содержимое.
 *
 * Нужен там, где блоки идут подряд и расстояния между ними заданы явно, — как
 * нарисовано в холстах: `padding: 0 16px` и отступы по месту. Вкуишная пара
 * Group + Div для этого не годится: у каждой свои вертикальные поля, и на
 * стопке из четырёх секций они складываются — между чипами и подписью раздела
 * набегало 56 px вместо двадцати, проверено замером.
 */
export function Gutter({ children }: { children: ReactNode }) {
  return <div className={styles.gutter}>{children}</div>;
}
